<div class="container-fluid"  *ngIf="isSectionVisible">
    <fieldset class="border rounded-3 p-1" [class.section-disabled]="isSectionLocked">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.TITLE' | translate}}
            <si-check-box *ngIf="optionalWorkflowCondition" [isReadMode]="false" [isDisabled]="isDisabled || isReadOnlyMode"
                [isChecked]="isContractualDocumentationChecked" (change)="onContractualDocumentationToggle($event)"></si-check-box>
        </legend>
<div class="row" [formGroup]="costReviewContractualDocumentationForm" trackChanges [appOptionalWorkflow]="optionalWorkflowCondition" [initialExpanded]="true">
<div class="col-sm-6">
    <div class="row bottomPadding" *ngIf="business!==constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.ORIGINAL_COMPLETION_DATE' | translate}}</mat-label>
        </div>
        <div class="col-sm-6 mt-3">
            <app-si-date-picker [value]="costReviewContractualDocumentationForm.get('originalCompletionDate')?.value ?? null" [isReadMode]="true"
                        [isDisabled]="isDisabled"></app-si-date-picker>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.SIEMENS_TERMS_AND_CONDITIONS_USED' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns" formControlName="siemensTermsConditionsUsed">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" >
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.WARRANTY_PERIOD_MONTHS' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <app-si-form-field [isReadMode]="isReadOnlyMode" 
             [isDisabled]="isSiemensTermsYes" [type]="'number'" [maxlength]="3" [max]="999" formControlName="warrantyPeriod"></app-si-form-field>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.LIQUIDATED_DAMAGES_LIABILITY' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <si-drop-down [inputValue]="costReviewContractualDocumentationForm.get('liquidatedDamagesLiability')?.value" [isReadMode]="isReadOnlyMode" [isDisabled]="isSiemensTermsYes" [dropDownList]="liquidatedDamagesLiabilityOptions"
             (inputValueChange)="costReviewContractualDocumentationForm.controls['liquidatedDamagesLiability'].setValue($event)"></si-drop-down>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.CONSEQUENTIAL_DAMAGES_IN_CONTRACT' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <si-drop-down [inputValue]="costReviewContractualDocumentationForm.get('consequentialDamagesInContract')?.value" [isReadMode]="isReadOnlyMode" [isDisabled]="isSiemensTermsYes" [dropDownList]="consequentialDamagesInContractOptions"
            (inputValueChange)="costReviewContractualDocumentationForm.controls['consequentialDamagesInContract'].setValue($event)"></si-drop-down>
         </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.WAIVER_REASON' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <si-drop-down [inputValue]="costReviewContractualDocumentationForm.get('waiverReason')?.value" [isReadMode]="isReadOnlyMode" [isDisabled]="isSiemensTermsYes" [dropDownList]="waiverReasonOptionsList"
            (inputValueChange)="costReviewContractualDocumentationForm.controls['waiverReason'].setValue($event)"></si-drop-down>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.FIRE_STOPPING' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <mat-radio-group class="radio-group radio-btns" formControlName="fireStopping">
                    <si-radio-button
                        [displayText]="'Siemens'"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'OTHER' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">    
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'SUBCONTRACTOR' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.PATCHING_AND_PAINTING' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <mat-radio-group class="radio-group radio-btns" formControlName="patchingPainting" >
                    <si-radio-button
                        [displayText]="'Siemens'"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'OTHER' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.DEMOLITION_OR_REMOVAL' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <mat-radio-group class="radio-group radio-btns" formControlName="demolitionRemoval">
                    <si-radio-button
                        [displayText]="'Siemens'"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'OTHER' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_SECURITY">
        <div class="col-sm-4">
            <mat-label class="margin-left-10">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.CLEAN_UP' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <mat-radio-group class="radio-group radio-btns" formControlName="cleanUp" >
                    <si-radio-button
                        [displayText]="'Siemens'"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'OTHER' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isSiemensTermsYes">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_SECURITY && business !== constants.BUSINESS_FIRE">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.POSSIBLE_CHANGE_ORDERS_IDENTIFIED' | translate}}</mat-label>
        </div>
        <div class="col-sm-6 break-word mb-3">
             <si-text-area formControlName="possibleChangeOrdersIdentified" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-text-area>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.PERFORMANCE_BOND_AMOUNT' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <app-si-currency-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" 
            formControlName="performanceBondAmount" [maxlength]="10" [max]="999999.99"></app-si-currency-field>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.PAYMENT_BOND_AMOUNT' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <app-si-currency-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
             formControlName="paymentBondAmount" [maxlength]="10" [max]="999999.99"></app-si-currency-field>
        </div>
    </div>
</div>
<div class="col-sm-6">
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.PENETRATION_REQUIREMENTS' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <si-check-box-group [options]="penetrationRequiredList" [singleRow]="true" [columnsPerRow]="3"
            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="penetrationRequirements"></si-check-box-group>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.TRAINING_SPECIFIED' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
             <mat-radio-group class="radio-group radio-btns" formControlName="trainingSpecified">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.CHANGE_ORDER_MARKUP_RESTRICTIONS' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns" formControlName="changeOrderMarkupRestrictions">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.CHANGE_ORDER_OPPORTUNITIES' | translate}}</mat-label>
        </div>
        <div class="col-sm-6 break-word mb-3">
            <si-text-area formControlName="changeOrderOpportunities" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
            ></si-text-area> 
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.SPECIAL_INSURANCE_CERTIFICATION' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
              <mat-radio-group class="radio-group radio-btns" formControlName="specialInsuranceCertification">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.LIABILITY_INSURANCE_SPECIAL_COVERAGE' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
              <mat-radio-group class="radio-group radio-btns" formControlName="liabilityInsurance">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business!==constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.DEDUCTIONS_OFFERED' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
              <mat-radio-group class="radio-group radio-btns" formControlName="deductionsOffered" >
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business!==constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.TESTING_PERIOD_FAT' | translate}}</mat-label>
        </div>
        <div class="col-sm-6 testing-period-fat-row">
            <mat-radio-group class="radio-group testing-period-radio-group" formControlName="testingFatDates">
                <si-radio-button
                    [displayText]="constants.NA"
                    [isReadMode]="isReadOnlyMode"
                    [isDisabled]="isDisabled"
                    formControlName="testingFatDates">
                </si-radio-button>
                <si-radio-button
                    [value]="'dates'"
                    [isReadMode]="isReadOnlyMode"
                    [isDisabled]="isDisabled"
                    formControlName="testingFatDates">
                </si-radio-button>
            </mat-radio-group>
            <div class="FAT-date-picker">
            <span class="from-label">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.FROM' | translate}}:</span>
            <app-si-date-picker [value]="getValueInString('testingFromDate')" [isReadMode]="isReadOnlyMode"
                [isDisabled]="isTestingDatesDisabled || isDisabled"
                (inputValueChange)="onTestingDateChange('testingFromDate', $event)"></app-si-date-picker>
            <span class="to-label">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.TO' | translate}}:</span>
            <app-si-date-picker [value]="getValueInString('testingToDate')" [isReadMode]="isReadOnlyMode"
                [isDisabled]="isTestingDatesDisabled || isDisabled"
                (inputValueChange)="onTestingDateChange('testingToDate', $event)" [minDate]="testingFromDateValue"></app-si-date-picker></div>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business!==constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.LICENSES_PERMITS' | translate}}</mat-label>
        </div>
        <div class="col-sm-6">
              <mat-radio-group class="radio-group radio-btns" formControlName="licensesPermits">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
        </div>
    </div>
    <div class="row bottomPadding" *ngIf="business!==constants.BUSINESS_FIRE && isSalePriceGreaterThan150">
        <div class="col-sm-4">
            <mat-label>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.SPECIAL_SAFETY_REQUIREMENTS' | translate}}</mat-label>
        </div>
        <div class="col-sm-6 break-word">
             <app-si-form-field [isReadMode]="isReadOnlyMode"  [maxlength]="40"
             [isDisabled]="isDisabled" formControlName="specialSafetyRequirements"></app-si-form-field>
        </div>
    </div>
</div>
</div>
    </fieldset>
</div>
<div class="container-fluid" *ngIf="isSectionNotApplicableShow()">
    <fieldset class="border rounded-3 p-1" >
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.TITLE' | translate}}</legend>
        <div class="row bottomPadding">
            <div class="col-sm-12">
                <span>{{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
            </div>
        </div>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="showSectionNotApplicableMsg && !costReviewContractualDocumentation">
    {{'REVIEW_SOL_CONTRACTUAL_DOCUMENTATION_TAB.CONTRACTUAL_DOCUMENTATION_DATA_NOT_FOUND' | translate}}
</div>


